(app => {

    app.service("casesDataTable",
        [
            "caseModalService", "caseApi", function(caseModalService, caseApi) {
                this.dataTableOptions = {
                    title: "Cases",
                };

                this.buildDataTableOptions = (cases, client) => {
                    this.dataTableOptions = {
                        ...this.dataTableOptions,
                        headers: [
                            {
                                title: "Name",
                                type: "string",
                            },
                            {
                                title: "Case Date",
                                type: "date",
                            },
                        ],
                        rows: cases.map(ca => {
                            return {
                                cells: [
                                    ca.Name,
                                    ca.CaseDate,
                                ],
                                rowObject: ca,
                                state: {
                                    name: "Home.Client.Case",
                                    params: { clientId: client.Id, caseId: ca.Id },
                                }
                            };
                        }),
                        rowActions: [
                            {
                                title: "Delete case",
                                iconName: "mdi-delete",
                                className: "btn-warning",
                                action: this.deleteCase,
                            },
                        ],
                        miscButtons: [
                            {
                                label: "Start New Case",
                                action: this.addCase,
                                params: [
                                    client,
                                ]
                            }
                        ]
                    };

                    return this.dataTableOptions;
                }

                this.deleteCase = (ca, $event) => {
                    caseModalService.confirmCaseDeletion($event).then(() => {
                        const rowIndex = this.dataTableOptions.rows.findIndex(row => {
                            return row.rowObject.Id === ca.Id;
                        });

                        this.dataTableOptions.rows.splice(rowIndex, 1);

                        caseApi.deleteCase(ca.Id);
                    });
                }

                this.addCase = ($event, params) => {
                    caseModalService.openAddCase(params[0], $event);
                }
            }
        ]);

})(window.app);